/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RemoveOrAddAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AddAction from './AddAction/index'
import React from 'react'
import RemoveAction from './RemoveAction/index'



/** @type {import('Simple/types.js').View} */
export default function RemoveOrAddAction({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/OrthodonticCoverage/RemoveOrAddAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'RemoveAction'
let planDetailsOrthoCoverageValueData = fromData.useDataFormat({ viewPath,
context: 'plan_details',
path: 'ortho_coverage',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: planDetailsOrthoCoverageValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'RemoveAction'}>
<RemoveAction
  viewPath={`${viewPath}/RemoveAction`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AddAction'}>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}